<template>
    <div>
        <b-modal id="modal-damage-items" @hide="fetch_init" scrollable title="DAMAGE ORDER" size="xl" hide-footer style="min-height: 700px;">
           <DamageOrderModal
                v-on:done-items-co="close_damage_modal"
                style="min-height: 700px;"
                :viewdata="modalViewData"
            />
        </b-modal>

        <b-alert :show="show==true">
            <b-button size="sm" variant="success" @click="add_new_damage_order">ADD NEW AS IS ORDER</b-button>
            <b-button size="sm" variant="primary" @click="fetch_init">
                <span v-if="!first_load">LOAD AS IS ORDERS</span>
                <span v-else>RELOAD</span>
            </b-button>
        </b-alert>

        <div v-if="first_load && items.length > 0">
          <!-- Mobile toggle button -->
          <div v-if="isMobile" class="d-flex justify-content-between align-items-center mb-2">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="filtersVisible = !filtersVisible"
            >
              <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
              {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
            </b-button>
          </div>

          <!-- Filters card -->
          <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
            <b-card style="background: #f2f2f2; margin-bottom: 10px;">
              <b-card-text>
                <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                  <div style="width: 250px;">
                    <div>LOCATION</div>
                    <b-form-select
                      :options="filterLocationOptions"
                      v-model="selectedLocation"
                    ></b-form-select>
                  </div>

                  <div style="width: 250px;">
                    <div>DAMAGE TYPE</div>
                    <b-form-select
                      :options="damageTypeOptions"
                      v-model="selectedDamageType"
                    ></b-form-select>
                  </div>

                  <div style="width: 250px;">
                    <div>DAMAGE GRADE</div>
                    <b-form-select
                      :options="damageGradeOptions"
                      v-model="selectedDamageGrade"
                    ></b-form-select>
                  </div>

                  <div style="width: 250px;">
                    <div>STATUS</div>
                    <b-form-select
                      :options="filterStatusOptions"
                      v-model="selectedStatus"
                    ></b-form-select>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </b-collapse>
        </div>

        <div v-if="items_being_loaded == true">
            <loading
                :active="true"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <div v-if="items_being_loaded == false">
                <div v-if="items.length == 0">
                    <div v-if="!first_load">
                    </div>
                    <div v-else>
                        <b-alert show variant="warning">NO DAMAGE ORDERS.</b-alert>
                    </div>
                </div>

                <div v-else>
                    <div v-if="(selectedLocation !== null || selectedDamageType !== null || selectedDamageGrade !== null || selectedStatus !== null) && displayItems.length === 0">
                        <b-alert show variant="info">No damage orders match the selected filters.</b-alert>
                    </div>
                    
                    <div class="diver">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <td class="srr" style="width: 120px; background-color: lightgoldenrodyellow;" @click="sortby('id')">ORDER #</td>
                                <td class="srr" style="width: 160px; background-color: lightgoldenrodyellow;" @click="sortby('created_by')">CREATED BY</td>
                                <td class="srr" style="width: 200px; background-color: lightgoldenrodyellow;" @click="sortby('location_id_name')">ORDERING LOCATION</td>
                                <td class="srr" style="width: 150px; background-color: lightgoldenrodyellow;" @click="sortby('ts')">ORDER DATE</td>
                                <td class="srr" style="width: 200px; background-color: lightgoldenrodyellow;" @click="sortby('selling_location_name')">SELLING LOCATION</td>
                                <td class="srr" style="width: 150px; background-color: lightgoldenrodyellow;" @click="sortby('damage_type')">DAMAGE TYPE</td>
                                <td class="srr" style="width: 150px; background-color: lightgoldenrodyellow;" @click="sortby('damage_grade')">DAMAGE GRADE</td>
                                <td class="srr" style="width: 150px; background-color: lightgoldenrodyellow;" @click="sortby('status')">STATUS</td>
                                <td class="srr" style="width: 160px; background-color: lightgoldenrodyellow;" @click="sortby('item_schedule_date')">SCHEDULE DATE</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('item_received_dates')">RECEIVING DATES</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('')">SKU</td>
                                <td class="srr" style="width: 180px; background-color: lightblue;" @click="sortby('')">ITEM DESCRIPTION</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('n_items')">ITEMS ORDERED</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('')">ITEMS RECEIVED</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('')">ITEMS REMAIN</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('total_value')">ORIGINAL VALUE</td>
                                <td class="srr" style="width: 150px; background-color: lightblue;" @click="sortby('salvage_value')">SALVAGE VALUE</td>
                                <td @click="sortby('approved')" class="srr" style="width: 200px; background-color: white;">ACTIONS</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in displayItems" v-bind:key="idx" :style="{background: ((item.approved) ? 'lightyellow': 'white')}">
                                <td class="srrv">{{ getPrefixedOrderId(item) }}</td>
                                <td class="srrv">{{item.created_by}}</td>
                                
                                <!-- Ordering Location - FIXED -->
                                <td class="srrv">
                                    <b-form-select 
                                        :options="locations" 
                                        v-model="item.location_id" 
                                        style="font-size: 14px;"
                                        :disabled="!!([3,4,5].includes(item.original_status))">
                                    </b-form-select>
                                </td>
                                
                                <td class="srrv">{{ formatDate(item.ts) }}</td>
                                
                                <!-- Selling Location - FIXED -->
                                <td class="srrv">
                                    <b-form-select 
                                        :options="selling_locations" 
                                        v-model="item.selling_location" 
                                        style="font-size: 14px;"
                                        :disabled="!!([3,4,5].includes(item.original_status))">
                                    </b-form-select>
                                </td>
                                
                                <!-- Damage Type -->
                                <td class="srrv">
                                    <b-form-select
                                        :options="damageTypes"
                                        v-model="item.damage_type"
                                        style="font-size: 14px;"
                                        :disabled="!!([3,4,5].includes(item.original_status))"
                                    ></b-form-select>
                                </td>
                                
                                <!-- Damage Grade -->
                                <td class="srrv">
                                    <b-form-select
                                        :options="damageGrades"
                                        v-model="item.damage_grade"
                                        style="font-size: 14px;"
                                        :disabled="!!([3,4,5].includes(item.original_status))"
                                    ></b-form-select>
                                </td>
                                
                                <!-- Status -->
                                <td class="srrv">
                                    <b-form-select
                                        :options="getStatusOptions(item)"
                                        style="font-size: 14px;"
                                        v-model="item.status"
                                        :disabled="!!(shouldDisableStatusChange(item))"
                                    ></b-form-select>
                                </td>
                                
                                <!-- Schedule Date -->
                                <td class="srrv">
                                    <date-picker
                                        v-model="item.schedule_date"
                                        format="MM-DD-YYYY"
                                        valueType="format"
                                        :disabled="[3,5,6].includes(item.original_status) || !hasOrderedItems(item)"
                                        style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;"
                                    ></date-picker>
                                </td>
                                
                                <!-- Other columns (unchanged) -->
                                <td class="srrv">
                                    <div v-if="item.showReceivingDates">
                                        <button v-if="getReceivingDates(item).length > 0" @click="item.showReceivingDates = false">HIDE</button>
                                        <div v-for="(date, idx) in getReceivingDates(item)" :key="idx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">{{ date }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button @click="item.showReceivingDates = true" :disabled="getReceivingDates(item).length === 0">
                                            SHOW {{ getReceivingDates(item).length }} DATES
                                        </button>
                                    </div>
                                </td>
                                <td class="srrv">
                                    <div v-if="item.showSKUs">
                                        <button v-if="getSKUs(item).length > 0" @click="item.showSKUs = false">HIDE</button>
                                        <div v-for="(sku, idx) in getSKUs(item)" :key="idx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">{{ sku }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button @click="item.showSKUs = true" :disabled="getSKUs(item).length === 0">
                                            SHOW {{ getSKUs(item).length }} SKUs
                                        </button>
                                    </div>
                                </td>
                                <td class="srrv">
                                    <div v-if="item.showProducts">
                                        <button v-if="getProductNames(item).length > 0" @click="item.showProducts = false">HIDE</button>
                                        <div v-for="(product, idx) in getProductNames(item)" :key="idx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">{{ product }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button @click="item.showProducts = true" :disabled="getProductNames(item).length === 0">
                                            SHOW {{ getProductNames(item).length }} PRODUCTS
                                        </button>
                                    </div>
                                </td>
                                <td class="srrv">{{ getTotalOrdered(item) }}</td>
                                <td class="srrv">{{ getTotalReceived(item) }}</td>
                                <td class="srrv">{{ getTotalRemaining(item) }}</td>
                                <td class="srrv">${{ formatCurrency(item.total_value) }}</td>
                                <td class="srrv">${{ formatCurrency(item.salvage_value) }}</td>
                                
                                <!-- Actions -->
                                <td class="srrv">
                                    <span v-if="item.loading">
                                        <loading
                                            :active="true"
                                            :can-cancel="false"
                                            :is-full-page="false">
                                        </loading>
                                    </span>
                                    <span v-else>
                                        <b-button
                                            size="sm"
                                            variant="outline-primary"
                                            @click="view_damage_order(item)"
                                            v-b-tooltip.hover title="VIEW"
                                            v-if="item.id"
                                        >
                                            <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button size="sm" variant="outline-success" @click="save_damage_order(item)" v-b-tooltip.hover title="SAVE" :disabled="shouldDisableRow(item)">
                                            <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            @click="delete_damage_order(item)"
                                            variant="outline-danger"
                                            :disabled="!canDeleteOrder(item)"
                                            v-if="item.username == item.created_by || ['admin', 'officemanager'].includes(packet.userDetails.userrole)"
                                            v-b-tooltip.hover :title="getDeleteButtonTooltip(item)"
                                        >
                                            <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            @click="approve_damage_order(item)"
                                            :variant="((item.approved) ? 'success' : 'outline-secondary')"
                                            v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)"
                                            v-b-tooltip.hover
                                            :title="((item.approved) ? 'APPROVED' : 'APPROVE')"
                                        >
                                            <b-icon icon="shield-check" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { BIconFunnelFill } from 'bootstrap-vue'
    import DamageOrderModal from '@/components/TransferOrders/DamageOrderModal';
import { create } from 'underscore';

    export default {
        name: "ListDamageOrders",
        components: { Loading, DatePicker, DamageOrderModal, BIconFunnelFill },
        data: function(){
            return {
                packet: {},
                show: true,
                first_load: null,
                items: [],
                items_being_loaded: null,
                damage_order_id: null,
                selected_status: null,
                products: [],
                locations: [],
                selling_locations: [],
                selectedLocation: null,
                selectedDamageType: null,
                selectedDamageGrade: null,
                selectedStatus: null,
                filterLocationOptions: [
                    { value: null, text: 'All Locations' },
                ],
                damageTypeOptions: [
                    { value: null, text: 'All Damage Types' },
                ],
                damageGradeOptions: [
                    { value: null, text: 'All Damage Grades' },
                ],
                filterStatusOptions: [
                    { value: null, text: 'All' },
                ],
                damageTypes: [
                    { value: 'physical', text: 'Physical Damage' },
                    { value: 'cosmetic', text: 'Cosmetic Damage' },
                    { value: 'functional', text: 'Functional Damage' },
                    { value: 'water', text: 'Water Damage' },
                    { value: 'shipping', text: 'Shipping Damage' },
                    { value: 'manufacturing', text: 'Manufacturing Defect' },
                    { value: 'other', text: 'Other' }
                ],
                damageGrades: [
                    { value: 'minor', text: 'Minor' },
                    { value: 'moderate', text: 'Moderate' },
                    { value: 'severe', text: 'Severe' },
                    { value: 'total', text: 'Total Loss' }
                ],
                statuses: [
                    {value: 1, text: "ORDERED"},
                    {value: 2, text: "SCHEDULED"},
                    {value: 3, text: "PARTIAL"},
                    {value: 4, text: "RECEIVED"},
                    {value: 5, text: "COMPLETED"},
                    {value: 6, text: "ARCHIVED"},
                ],
                sort_asc: true,
                filtersVisible: false,
                isMobile: false,
                modalViewData: {}
            }
        },
        watch: {
            selectedLocation() {
                this.applyFilters();
            },
            selectedDamageType() {
                this.applyFilters();
            },
            selectedDamageGrade() {
                this.applyFilters();
            },
            selectedStatus() {
                this.applyFilters();
            }
        },
        methods: {
            formatCurrency(value) {
                const numValue = Number(value) || 0;
                return numValue.toFixed(2);
            },
            formatDate: function(timestamp) {
                if (!timestamp) return 'N/A';
                return moment(timestamp).format('MM-DD-YYYY');
            },
            getPrefixedOrderId(item) {
                if (!item.id) return 'NEW DAMAGE ORDER';
                const locationName = this.getLocationNameById(item.location_id);
                const prefix = locationName ? this.locationPrefixes[locationName] : 'DAM';
                return `${prefix}-${item.id}`;
            },
            getLocationNameById(locationId) {
                if (!locationId) return null;
                const location = this.locations.find(loc => loc.value === parseInt(locationId));
                return location ? location.text : null;
            },
            getSellingLocationNameById(locationId) {
                if (!locationId) return null;
                const location = this.selling_locations.find(loc => loc.value === parseInt(locationId));
                return location ? location.text : null;
            },
            locationPrefixes: {
                'ALLENTOWN STORE': 'DAM-AT',
                'MECCA SHIPPING': 'DAM-MS',
                '101 WH': 'DAM-VEN',
                'FOLCROFT': 'DAM-FOL',
                '9TH ST ': 'DAM-9',
                'VENANGO STORE': 'DAM-101',
                'READING STORE': 'DAM-RD',
                'LANCASTER AVE STORE': 'DAM-56',
                'EWING STORE': 'DAM-EW',
                'DELMAR STORE': 'DAM-FLC',
                'LANSDOWNE STORE': 'DAM-BLT',
                'UPPER DARBY STORE': 'DAM-UD',
                'HUNTING PARK STORE': 'DAM-HP',
            },
            canDeleteOrder(item) {
                return item.status === 1; // Only allow deletion of DRAFT orders
            },
            getDeleteButtonTooltip(item) {
                return this.canDeleteOrder(item)
                    ? "DELETE"
                    : "Only draft orders can be deleted";
            },
            shouldDisableStatusChange(item) {
                return [3, 4, 5, 6].includes(item.original_status);
            },
            shouldDisableRow(item) {
                if (!item) return true;
                if (!this.isAdmin() && [3,4,5,6].includes(item.status)) {
                    return true;
                }
                return false;
            },
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },
            hasOrderedItems(item) {
                if (!item.items || !Array.isArray(item.items)) return false;
                return item.items.some(i => (parseInt(i.quantity) || 0) > 0);
            },
            getReceivingDates(item) {
                if (!item.items || !Array.isArray(item.items)) return [];
                return [...new Set(item.items
                    .filter(i => i.received_date && i.received_date !== 'null')
                    .map(i => i.received_date)
                )];
            },
            getSKUs(item) {
                if (!item.items || !Array.isArray(item.items)) return [];
                return [...new Set(item.items.map(i => i.product_sku))];
            },
            getProductNames(item) {
                if (!item.items || !Array.isArray(item.items)) return [];
                return [...new Set(item.items.map(i => i.product_name))];
            },
            getTotalOrdered(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => sum + (parseInt(i.quantity) || 0), 0);
            },
            getTotalReceived(item) {
                if (!item.items || !Array.isArray(item.items)) return 0;
                return item.items.reduce((sum, i) => sum + (parseInt(i.quantity_received) || 0), 0);
            },
            getTotalRemaining(item) {
                return this.getTotalOrdered(item) - this.getTotalReceived(item);
            },
            applyFilters() {
                if (!Array.isArray(this.items)) {
                    this.filteredItems = [];
                    return;
                }

                this.filteredItems = this.items.filter(item => {
                    if (!item) return false;

                    const locationMatch = this.selectedLocation === null ||
                                        item.location_id === this.selectedLocation;

                    const damageTypeMatch = this.selectedDamageType === null ||
                                          item.damage_type === this.selectedDamageType;

                    const damageGradeMatch = this.selectedDamageGrade === null ||
                                           item.damage_grade === this.selectedDamageGrade;

                    const statusMatch = this.selectedStatus === null ||
                                      item.status === this.selectedStatus;

                    return locationMatch && damageTypeMatch && damageGradeMatch && statusMatch;
                });
            },
            getStatusOptions(item) {
                return this.statuses.map(status => {
                    let disabled = false;
                    if ([3, 4, 5, 6].includes(item.original_status)) {
                        disabled = true;
                    }
                    return { ...status, disabled };
                });
            },
            approve_damage_order: function(item){
                if (item.approved) return;
                
                let path = "/api/sales/approve_damage_order/"
                let data = {"id": item.id, "approved": true}
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR APPROVING DAMAGE ORDER.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else {
                        that.$bvToast.toast(
                            "SUCCESS APPROVING DAMAGE ORDER.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        if (response.data.result.length > 0){
                            let approved = response.data.result[0]["approved"];
                            item.approved = approved;
                        }
                    }
                    item.loading = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH APPROVING DAMAGE ORDER. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
          save_damage_order: function(item){
    let data = {
        id: item.id ? parseInt(item.id) : null,
        location_id: item.location_id ? parseInt(item.location_id) : null,
        selling_location: item.selling_location ? parseInt(item.selling_location) : null,
        damage_type: item.damage_type || null,
        damage_grade: item.damage_grade || null,
        status: item.status ? parseInt(item.status) : null,
        schedule_date: item.schedule_date || null,
        comments: item.comments || null,
        created_by: item.created_by || this.packet.userDetails.username,
    };
    
    let path = "/api/sales/record_damage_order/"
    if (item.id){
        path = "/api/sales/update_damage_order/"
    }

    let that = this;
    let s = function(response) {
        if (response.data.error){
            that.$bvToast.toast(
                "ERROR SAVING DAMAGE ORDER.",
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        } else {
            that.$bvToast.toast(
                "SUCCESSFULLY SAVED DAMAGE ORDER.",
                {title: "Success", autoHideDelay: 1500, variant:"success"}
            );
            if (response.data.result.length > 0){
                let id = response.data.result[0].id;
                item.id = id;
            }
        }
        item.loading = false;
    }
    let f = function(error) {
        that.$bvToast.toast(
            "ERROR OCCURRED WITH SAVING DAMAGE ORDER. TRY AGAIN LATER.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        item.loading = false;
    }
    item.loading = true;
    Requestor.postSyncP(path, data, this, s, f);
},
            fetch_init: function(){
                let data = {}
                let path = "/api/sales/get_damage_orders/"
                if (!['admin', 'officemanager'].includes(this.packet.userDetails.userrole) && this.packet.userDetails.properties.location_id){
                    data.location_id = parseInt(this.packet.userDetails.properties.location_id);
                    data.user_role = this.packet.userDetails.userrole;
                }
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING DAMAGE ORDERS.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else {
                        if (response.data.result) {
                            that.items = response.data.result.map(item => ({
                                ...item,
                                original_status: item.status,
                                total_value: Number(item.total_value) || 0,
                                salvage_value: Number(item.salvage_value) || 0,
                                n_items: Number(item.n_items) || 0,
                                n_products: Number(item.n_products) || 0,
                                showReceivingDates: false,
                                showSKUs: false,
                                showProducts: false,
                                // Ensure location_id and selling_location are numbers for the dropdowns
                                location_id: item.location_id ? parseInt(item.location_id) : null,
                                selling_location: item.selling_location ? parseInt(item.selling_location) : null
                            }));
                        }
                        that.first_load = true;
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH DAMAGE ORDERS. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            add_new_damage_order: function(){
                if (this.items.filter(function(d){return !(d.id) }).length > 0){
                    this.$vex.dialog.alert(
                        {message: "PLEASE SAVE THE EXISTING NEW ORDER FIRST."}
                    );
                    return
                }

                let defaultLocation = null;
                if (!['admin', 'officemanager'].includes(this.packet.userDetails.userrole)) {
                    const userLocationId = this.packet.userDetails.properties.location_id;
                    if (userLocationId) {
                        defaultLocation = parseInt(userLocationId);
                    }
                }

                let item = {
                    id: null,
                    created_by: this.packet.userDetails.username,
                    location_id: defaultLocation,
                    damage_type: 'physical',
                    damage_grade: 'minor',
                    status: 1,
                    original_status: 1,
                    ts: new Date().toISOString(),
                    comments: null,
                    schedule_date: null,
                    is_new: true,
                    selling_location: null,
                    total_value: 0,
                    salvage_value: 0,
                    n_items: 0,
                    n_products: 0,
                    showReceivingDates: false,
                    showSKUs: false,
                    showProducts: false,
                    items: []
                }
                this.items.splice(0, 0, item);
            },
            delete_damage_order: function(item){
                if (!item.id){
                    this.items = this.items.filter(function(d){return d.id})
                } else {
                    let path = "/api/sales/delete_damage_order/"
                    let data = {id: item.id}
                    let that = this;

                    let s = function(response) {
                        if (response.data.error){
                            that.$bvToast.toast(
                                "ERROR DELETING DAMAGE ORDER",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        } else {
                            that.$bvToast.toast(
                                "DELETED DAMAGE ORDER",
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                            that.fetch_init();
                        }
                        that.items_being_loaded = false;
                    }
                    let f = function(error) {
                        that.$bvToast.toast(
                            "ERROR OCCURRED.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }
                    this.items_being_loaded = true;
                    Requestor.postSyncP(path, data, this, s, f);
                }
            },
            view_damage_order: function(item){
                this.damage_order_id = item.id;
                this.selected_status = item.status;
                this.show_damage_modal(item);
            },
            show_damage_modal: function(item){
                if (!item){
                    this.damage_order_id = null;
                    this.selected_status = null;
                } else {
                    this.damage_order_id = item.id;
                    this.selected_status = item.status;
                }
                
                // Get location names for the selected item
                const orderingLocationName = this.getLocationNameById(item.location_id);
                const sellingLocationName = this.getSellingLocationNameById(item.selling_location);
                
                console.log('Opening modal with locations:', {
                    orderingId: item.location_id,
                    orderingName: orderingLocationName,
                    sellingId: item.selling_location,
                    sellingName: sellingLocationName
                });
                
                this.modalViewData = {
                    id: this.damage_order_id,
                    products: this.products,
                    status: this.selected_status,
                    location_id: item ? item.location_id : null,
                    selling_location: item ? item.selling_location : null,
                    ordering_location_name: orderingLocationName,
                    selling_location_name: sellingLocationName
                };
                
                this.$bvModal.show("modal-damage-items");
            },
            close_damage_modal: function(){
                this.$bvModal.hide("modal-damage-items");
                this.fetch_init();
            },
            sortby: function(key, mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key, mapper)
                } else {
                    this.items = Requestor.sort_reverse(this.items, key, mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
        },
        mounted() {
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            displayItems() {
                if ((this.selectedLocation !== null ||
                    this.selectedDamageType !== null ||
                    this.selectedDamageGrade !== null ||
                    this.selectedStatus !== null) &&
                    this.filteredItems.length === 0) {
                    return [];
                }
                return (this.selectedLocation !== null ||
                        this.selectedDamageType !== null ||
                        this.selectedDamageGrade !== null ||
                        this.selectedStatus !== null) ?
                    this.filteredItems :
                    this.items;
            },
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            // Initialize filter options
            let allLocations = this.packet.locations.filter(function(d) { return d.text != 'All' });
            
            this.filterLocationOptions = [
                { value: null, text: 'All Locations' },
                ...allLocations.map(loc => ({
                    value: loc.value,
                    text: loc.text
                }))
            ];

            this.damageTypeOptions = [
                { value: null, text: 'All Damage Types' },
                ...this.damageTypes
            ];

            this.damageGradeOptions = [
                { value: null, text: 'All Damage Grades' },
                ...this.damageGrades
            ];

            this.filterStatusOptions = [
                { value: null, text: 'All' },
                ...this.statuses
            ];

            // Set locations based on user role
            if (!['admin', 'officemanager'].includes(this.packet.userDetails.userrole)) {
                const userLocationId = this.packet.userDetails.properties.location_id;
                this.locations = allLocations.filter(function(d) {
                    return d.value == userLocationId;
                });
            } else {
                this.locations = allLocations;
            }
            
            // Set selling locations
            if (this.packet.userDetails.userrole !== 'admin') {
                // For non-admin users, show only warehouse locations or specific ones
                this.selling_locations = allLocations.filter(function(d) {
                    return [40, 41, 42].includes(d.value); // Adjust as needed
                });
            } else {
                // For admin users, show all locations except 'All'
                this.selling_locations = allLocations.filter(function(d) {
                    return d.text != 'All';
                });
            }
        }
    }
</script>

<style scoped>
.diver {
    overflow: auto;
    width: 100%;
    height: 600px;
}

td, th {
    border: 1px solid;
    width: 300px;
}

th {
    background-color: white;
}

table {
    table-layout: fixed;
    width: 100%;
}

table tr td:first-child {
    position: sticky;
    left: 0;
    background-color: white; /* Match your background */
    z-index: 1;
}

/* Make last column (ACTIONS) sticky */
table tr td:last-child {
    position: sticky;
    right: 0;
    background-color: white; /* Match your background */
    z-index: 1;
}

/* Ensure header cells are also sticky */
table thead tr td:first-child {
    position: sticky;
    left: 0;
    background-color: lightgray; /* Match your header background */
    z-index: 2;
}

table thead tr td:last-child {
    position: sticky;
    right: 0;
    background-color: lightgray; /* Match your header background */
    z-index: 2;
}

.srr {
    font-size: 14px;
    text-align: center;
    background: #ffeaa7;
    border: 1px solid #010101;
    font-weight: bold;
}

.srrv {
    font-size: 14px;
    text-align: center;
    border: 1px solid #010101;
    padding: 5px;
}

.box {
    padding: 3px;
    text-align: center;
    margin: 5px;
    background: #c8e6c9;
    color: black;
    border: 1px solid black;
}

@media (max-width: 768px) {
    .diver {
        height: auto;
        overflow-x: auto;
        overflow-y: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/TransferOrders/ListDamageOrders.vue